<template>
  <MtxPage width="md" v-if="commit">
    <template #header>
      <h1>Commit {{ commit.hash | commitHash }}</h1>
      <h3>{{ (commit.timestamp * 1000) | date("MMM Do, YYYY") }}</h3>
    </template>

    <div class="grid grid-2-columns@sm grid-gap">
      <MtxCard>
        <h5>Created by</h5>
        <p class="ml-2 mb-4">
          <ProfileLink :address="commit.owner" copy />
        </p>

        <template v-if="commit.parentHash">
          <h5>Parent Commit</h5>
          <p class="ml-2 mb-4">
            <RouterLink :to="`/commits/${commit.parentHash}`">
              {{ commit.parentHash | commitHash }}
            </RouterLink>
          </p>
        </template>

        <template v-if="commit.children.length">
          <h5>Children Commits</h5>
          <ul class="list-plain ml-2">
            <li v-for="child of commit.children" :key="child">
              <RouterLink :to="`/commits/${child}`">
                {{ child | commitHash }}
              </RouterLink>
            </li>
          </ul>
        </template>

        <template v-if="commit.submissions.length">
          <h5>Submissions Made</h5>
          <ul class="list-plain ml-2">
            <li v-for="submission of commit.submissions" :key="submission.hash">
              <RouterLink :to="`/submissions/${submission.hash}`" class="heading-6 mb-0">
                {{ submission.title | truncate }}
              </RouterLink>
              <div>
                <small>
                  submitted to
                  <RouterLink :to="`/tournaments/${submission.tournament}`">
                    {{ submission.tournament | ethAddress }}
                  </RouterLink>
                </small>
              </div>
            </li>
          </ul>
        </template>
      </MtxCard>
      <MtxCard>
        <h5>Commit Value</h5>
        <p class="ml-2 mb-4">
          {{ commit.value | mtx }}
        </p>

        <h5>Chain Equity</h5>
        <p class="ml-2 mb-4">{{ chainPercentage }}%</p>

        <h5>Commit Content</h5>
        <p class="ml-2">
          <a :href="`https://ipfs.infura.io/ipfs/${commit.ipfsContent}/`" target="_blank">
            View Files on IPFS
          </a>
        </p>
      </MtxCard>
    </div>
  </MtxPage>
</template>

<script>
import nprogress from "@/mixins/nprogress"
import API from "@/api"

export default {
  mixins: [nprogress],

  props: {
    commitHash: {
      type: String,
      required: true
    }
  },

  data: () => ({
    commit: null
  }),

  metaInfo() {
    const content = this.commit ? `Commit by ${this.commit.owner}` : "A Matryx commit"
    return {
      titleTemplate: `%s | Single Commit`,
      meta: [{ name: "description", content }]
    }
  },

  computed: {
    chainPercentage() {
      const ratio = this.commit.ownerTotalValue / this.commit.totalValue
      return Math.round(1000 * ratio) / 10
    }
  },

  watch: {
    commitHash: {
      handler: "getCommit",
      immediate: true
    }
  },

  methods: {
    async getCommit() {
      this.commit = null
      this.isLoading = true

      const { success, data } = await API.getCommit(this.commitHash)
      if (success) {
        this.commit = data.commit
      }

      this.isLoading = false
    }
  }
}
</script>
